import React from 'react';
import { useConnect } from '@lore/query-connect';
import { SparklesIcon } from '@heroicons/react/24/outline';
import useRouter from '../../hooks/useRouter';
import Urls from '../project-create/Urls';
import DataCard from '../profile-edit/DataCard';
import usePageRouter from '../../dialogs-routable/_hooks/usePageRouter';

export default function Activity(props) {
  const { project } = props;
  const { history } = usePageRouter();

  const activity = useConnect('tag.byId', {
    id: project.data.activityId
  });

  return (
    <DataCard
      title="Activity"
      icon={SparklesIcon}
      subtitle={activity.data.name || '...'}
      onClick={() => history.push(Urls(project).ACTIVITY)}
    />
  );
};
